import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { apiErrorMessage } from "@/lib/api";

export const LoginView = ({ onSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      toast.success("Accesso effettuato", { description: `Benvenuto, ${data.user.name}` });
      onSuccess(data.user);
    } catch (err) {
      setError(apiErrorMessage(err, "Accesso non riuscito. Verifica le credenziali."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-5" data-testid="admin-login-screen">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center gap-3 text-center">
          <img src="/brand/emblem.png" alt="Logo" className="h-16 w-16 object-contain" />
          <h1 className="font-serif text-2xl text-white">Area Riservata</h1>
          <p className="text-sm text-slate-400">Studio Legale Avv. Giuseppe Napolitano</p>
        </div>
        <form onSubmit={submit} className="mt-8 border border-white/10 bg-white p-8">
          <div className="flex flex-col gap-5">
            <div>
              <Label htmlFor="admin-email">Email</Label>
              <Input id="admin-email" type="email" data-testid="admin-username-input" className="mt-2" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="admin-password">Password</Label>
              <Input id="admin-password" type="password" data-testid="admin-password-input" className="mt-2" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="bg-gold px-6 py-3 text-sm font-semibold uppercase tracking-wider text-navy transition-colors hover:bg-gold-light disabled:opacity-60">
              {loading ? "Accesso in corso..." : "Accedi"}
            </button>
          </div>
        </form>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-gold transition-colors" data-testid="admin-back-to-site">
          <ArrowLeft className="h-4 w-4" /> Torna al sito
        </Link>
      </div>
    </div>
  );
};
